export const PageProviderSymbol = Symbol('PageProvider')

export const name = 'pages' as const
